<ngx-stripe-card
  [options]="cardOptions"
  [elementsOptions]="elementsOptions"
  (change)="handleChange($event)"
></ngx-stripe-card>
